import type { LeaderboardEntry, PlayerCutStatus } from './types';
export interface CutRuleResult {
  cutLineScore: number | null;
  projectedCutLineScore: number | null;
  playersMakingCut: string[];
  playersMissingCut: string[];
  tieCount: number;
  playerStatus: Record<string, PlayerCutStatus>;
}
export class CutRuleEngine {
  evaluate(
    entries: Pick<LeaderboardEntry, 'golferId' | 'total' | 'finished'>[],
    topN = 65,
    final = false,
  ): CutRuleResult {
    const sorted = [...entries].sort((a, b) => a.total - b.total);
    const index = Math.min(Math.max(topN, 1), sorted.length) - 1;
    const line = sorted[index]?.total ?? null;
    const making =
      line === null ? [] : sorted.filter((e) => e.total <= line).map((e) => e.golferId);
    const made = new Set(making);
    const statuses: Record<string, PlayerCutStatus> = {};
    sorted.forEach(
      (e) =>
        (statuses[e.golferId] = final
          ? made.has(e.golferId)
            ? 'madeCut'
            : 'missedCut'
          : e.total === line
            ? 'onLine'
            : made.has(e.golferId)
              ? e.finished
                ? 'safe'
                : 'projectedIn'
              : 'projectedOut'),
    );
    return {
      cutLineScore: final ? line : null,
      projectedCutLineScore: line,
      playersMakingCut: making,
      playersMissingCut: sorted.filter((e) => !made.has(e.golferId)).map((e) => e.golferId),
      tieCount: line === null ? 0 : sorted.filter((e) => e.total === line).length,
      playerStatus: statuses,
    };
  }
}
